// Development environment configuration for CI builds
// This file is used when building with `ng build -c=dev` (develop branch CI)

export const environment = {
  production: false,
  // QSL-9530: Cloud Run dev API (needed for the deployed develop build).
  // For LOCAL development, temporarily change to "http://localhost:3111/api"
  // but do NOT commit that change — revert before pushing.
  apiURL: "https://qupil-dev-app-60148088351.europe-west6.run.app/api",
  createLectureFeatureFlag: true,
  appId: "7b4c4b38fb1545b8a76627bd64faf244",
  firebase: {
    apiKey: "AIzaSyDz7JfbialMrCcMnVExt8in91Ka5TS8NoQ",
    authDomain: "qupil-345111.firebaseapp.com",
    databaseURL:
      "https://qupil-345111-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "qupil-345111",
    storageBucket: "qupil-345111.appspot.com",
    messagingSenderId: "60148088351",
    appId: "1:60148088351:web:469a3f4f75cf598d665f2a",
    measurementId: "G-6YX762CE86",
  },
  vapidKey: "BFjfNv-eY5yo64Igx3naBqN1qDSp8LL-R_lHnzoaskIKbB6hoh6UwuXaL7P6PZdrfisOnFASzspBsMw0vmfbdKw",
  intercomAppId: "shbk4qqg",
  intercomSecretKey: "DzC51VWC0d8kH2edzRv0nQm2WGpExkwH8a8fT95o",
  // QSL-9530: Stripe test bed (sandbox). stripePublishableKey must be a *test-mode* key.
  stripeTestBedEnabled: true,
  stripePublishableKey:
    "pk_test_51KQTX5DzOBLQKUiq5ZXUsl4f6Ugk9MsBBWGRs5iD2k3XZ0HqnJairbTECkfz12U6wdfzRPHsivVOMx5l4hg8Cv7u00pg9objmE",
};
